import _toArray from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/toArray";
import { struct, u8 } from '@solana/buffer-layout';
import { u64 } from '@solana/buffer-layout-utils';
import { TransactionInstruction } from '@solana/web3.js';
import { TOKEN_PROGRAM_ID } from '../constants.js';
import { TokenInvalidInstructionDataError, TokenInvalidInstructionKeysError, TokenInvalidInstructionProgramError, TokenInvalidInstructionTypeError } from '../errors.js';
import { addSigners } from './internal.js';
import { TokenInstruction } from './types.js';
/** TODO: docs */

export var mintToInstructionData = struct([u8('instruction'), u64('amount')]);
/**
 * Construct a MintTo instruction
 *
 * @param mint         Public key of the mint
 * @param destination  Address of the token account to mint to
 * @param authority    The mint authority
 * @param amount       Amount to mint
 * @param multiSigners Signing accounts if `authority` is a multisig
 * @param programId    SPL Token program account
 *
 * @return Instruction to add to a transaction
 */

export function createMintToInstruction(mint, destination, authority, amount) {
  var multiSigners = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var programId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : TOKEN_PROGRAM_ID;
  var keys = addSigners([{
    pubkey: mint,
    isSigner: false,
    isWritable: true
  }, {
    pubkey: destination,
    isSigner: false,
    isWritable: true
  }], authority, multiSigners);
  var data = Buffer.alloc(mintToInstructionData.span);
  mintToInstructionData.encode({
    instruction: TokenInstruction.MintTo,
    amount: BigInt(amount)
  }, data);
  return new TransactionInstruction({
    keys: keys,
    programId: programId,
    data: data
  });
}
/**
 * Decode a MintTo instruction and validate it
 *
 * @param instruction Transaction instruction to decode
 * @param programId   SPL Token program account
 *
 * @return Decoded, valid instruction
 */

export function decodeMintToInstruction(instruction) {
  var programId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOKEN_PROGRAM_ID;
  if (!instruction.programId.equals(programId)) throw new TokenInvalidInstructionProgramError();
  if (instruction.data.length !== mintToInstructionData.span) throw new TokenInvalidInstructionDataError();

  var _decodeMintToInstruct = decodeMintToInstructionUnchecked(instruction),
      _decodeMintToInstruct2 = _decodeMintToInstruct.keys,
      mint = _decodeMintToInstruct2.mint,
      destination = _decodeMintToInstruct2.destination,
      authority = _decodeMintToInstruct2.authority,
      multiSigners = _decodeMintToInstruct2.multiSigners,
      data = _decodeMintToInstruct.data;

  if (data.instruction !== TokenInstruction.MintTo) throw new TokenInvalidInstructionTypeError();
  if (!mint || !destination || !authority) throw new TokenInvalidInstructionKeysError(); // TODO: key checks?

  return {
    programId: programId,
    keys: {
      mint: mint,
      destination: destination,
      authority: authority,
      multiSigners: multiSigners
    },
    data: data
  };
}
/**
 * Decode a MintTo instruction without validating it
 *
 * @param instruction Transaction instruction to decode
 *
 * @return Decoded, non-validated instruction
 */

export function decodeMintToInstructionUnchecked(_ref) {
  var programId = _ref.programId,
      _ref$keys = _toArray(_ref.keys),
      mint = _ref$keys[0],
      destination = _ref$keys[1],
      authority = _ref$keys[2],
      multiSigners = _ref$keys.slice(3),
      data = _ref.data;

  return {
    programId: programId,
    keys: {
      mint: mint,
      destination: destination,
      authority: authority,
      multiSigners: multiSigners
    },
    data: mintToInstructionData.decode(data)
  };
}